import React from "react";
import TableRow from "../../../../Components/Common/TableRow";
import { convertToLocalDateTime } from "../../../../utils/convertToLocalDateTime";
import TableRowPerAction from "../../../../Components/Common/TableRowPerAction";
import { useAlert } from "../../../../Context/AlertContext";
import useToastError from "../../../../hooks/useErrorToast";
import useSWRMutation from "swr/mutation";
import TableData from "../../../../Components/Common/TableData";
import { subchapterQuestionUrls } from "../../../../Api/Auth/ApiUrls";
import { sendDeleteRequestAuth } from "../../../../Api/swrConfig";
import { toast } from "react-toastify";

const QuestionRow = ({
  pagination,
  index,
  row,
  mutate,
  onEditClick,
  length,
}) => {
  const { showAlert, setIsLoading } = useAlert();
  const { showErrorToast } = useToastError();

  const { trigger: deleteTrigger } = useSWRMutation(
    subchapterQuestionUrls.delete(row._id),
    sendDeleteRequestAuth,
    {
      onSuccess: () => {
        setIsLoading(false);
        toast.success("Success");
        mutate();
      },
      // If error occurred - make delete false
      onError: (error) => {
        setIsLoading(false);
        showErrorToast(error);
      },
    }
  );

  const handleDelete = () => {
    showAlert(`Are you sure you want to delete the question ?`, async () => {
      setIsLoading(true);
      await deleteTrigger(row._id);
    });
  };

  const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  // Calculate the correct global index accounting for pagination offset
  const displayIndex = pagination.totalItems - (pagination.offset + index);

  return (
    <>
      <TableRow key={row._id}>
        <TableData>{row.No}</TableData>
        <TableData className="align-middle">
          {row.questionText ? (
            <span className="block w-40 truncate">
              {stripHtml(row.questionText)}
            </span>
          ) : row.questionImage ? (
            <div className="w-16 h-16 overflow-hidden rounded border border-primary">
              <img
                src={row.questionImage}
                alt="Question"
                className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105"
              />
            </div>
          ) : (
            ""
          )}
        </TableData>

        <TableData>{convertToLocalDateTime(row.createdAt)}</TableData>
        <TableRowPerAction
          onEdit={() => onEditClick(row, displayIndex)}
          onDelete={handleDelete}
        />
      </TableRow>
    </>
  );
};

export default QuestionRow;
